export const types = {

    startLogIn: '[Auth] Login',
    startRegister: '[Auth] Register',
    startLogOut: '[Auth] Logout cerrar sesión',
    authCheckingFinish: '[Auth] finish login state',
    startLogin: '[Auth] Login',

    startLoadUsers : '[User] Load Users',
    startTotalUsers: '[User] total Users',
    startDeleteUser: '[User] Delete User',
    startUpdateUser: '[User] Update User',

    startPrudctLoading: '[Product] Load Product',
    startTotalProducts: '[Product] Total Product',
    startUpdateProduct: '[Product] Update Product',

    startCategoryLoad: '[Category] Load Category',


    startGetbyCategory: '[Category] Menu by category',

    startLoadingRoles : '[Rol] Load Roles',

    startLoading: '[Ui] Start Loading',
    endLoading: '[Ui] End Loading',
    startSuccessMessage: '[Ui] Show Messague',
    endSuccessMessage: '[Ui] Close Message',


}